import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './pages/Auth/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { WishlistProvider } from './pages/wishlist/WishlistContext';
import { MobileNavigationProvider } from './contexts/MobileNavigationContext';
import ScrollToTop from './shared/utils/ScrollToTop';
import IndexPage from './pages/index/index';
import ViewAll from './pages/ViewAll/ViewAll';
import Cart from './pages/Cart/Cart';
import Checkout from './pages/Checkout/Checkout';
import ViewProducts from './pages/ViewProducts/ViewProducts';
import ProductDetail from './pages/ProductDetail/ProductDetail';
import ProductTracker from './pages/ProductTracker/ProductTracker';
import Profile from './pages/Profile/Profile';
import AuthPage from './pages/Auth/AuthPage';
import SearchResults from './pages/index/components/Header/Search/SearchResults';
import './pages/index/components/Header/styles/Header.css';
import Wishlist from './pages/wishlist/Wishlist';
import OrderConfirmation from './pages/Cart/components/OrderConfirmation/OrderConfirmation';
import AuthMobile from './pages/Auth/AuthMobile';
import useIsMobile from './shared/hooks/useIsMobile';
import Terms from './shared/components/footer/Terms';
import Privacy from './shared/components/footer/Privacy';
import Refund from './shared/components/footer/Refund';
import Support from './shared/components/footer/Support';

const App: React.FC = () => {
  const isMobile = useIsMobile();
  const AuthComponent = isMobile ? AuthMobile : AuthPage;

  return (
    <AuthProvider>
      <CartProvider>
        <WishlistProvider>
          <MobileNavigationProvider>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<IndexPage />} />
              <Route path="/view-products/:slug" element={<ViewProducts />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/categories/view-all" element={<ViewAll />} />
              <Route path="/track-order/:orderId" element={<ProductTracker />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/track-order" element={<div className="main-content"><ProductTracker /></div>} />
              <Route path="/order-confirmation" element={<OrderConfirmation />} />
              <Route path="/search" element={<SearchResults />} />
              <Route path="/auth" element={<AuthComponent />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/refund" element={<Refund />} />
              <Route path="/support" element={<Support />} />
            </Routes>
            <ToastContainer />
          </MobileNavigationProvider>
        </WishlistProvider>
      </CartProvider>
    </AuthProvider>
  );
};

export default App;